import ThemeColours from "@onhandtech/onhand-toolkit/lib/src/themes/default/colours";

export const QR_CODE_DEFAULT_URL = "https://www.beonhand.co.uk";

export const QR_CODE_STATIC_DIR = "/static/img/qr-code-images/";
export const QR_CODE_LOGOS = ["onhand_logo.png", "onhand_logo_circle.png"];
export const QR_CODE_EMOJIS = [
  'alarm.png',
  'bikewheel.png',
  'biscuit.png',
  'blood.png',
  'bread.png',
  'carrot.png',
  'cat.png',
  'clipboard.png',
  'coffeecup.png',
  'coins.png',
  'dog.png',
  'gloves.png',
  'hi-vis.png',
  'notebook.png',
  'paperplane.png',
  'phone.png',
  'plant.png',
  'podium.png',
  'prideflag.png',
  'ribbon.png',
  'sanitary-pad.png',
  'shoe.png',
  'shopdrop.png',
  'shovel.png',
  'teacup.png',
  'wardrobe.png',
  'washing-machine.png',
  'wheelbarrow.png',
  'basket.png',
  'beanie.png',
  'bin.png',
  'bus.png',
  'can.png',
  'car.png',
  'coat.png',
  'earth.png',
  'giftbox.png',
  'graduation-cap.png',
  'laptop.png',
  'letter.png',
  'litter-picker.png',
  'tap.png',
  'thread.png',
  'train.png',
  'tree-planting.png',
  'tree.png',
  'tshirt.png',
]

export const DEFAULT_IMAGE_URL = `${QR_CODE_STATIC_DIR}onhand_logo.png`;

export const QR_CODE_ALLOWED_COLOURS = [
	ThemeColours.cotton,
	ThemeColours.earth,
	ThemeColours.sunshine,
	ThemeColours.mint,
	ThemeColours.raspberry,
	ThemeColours.icing,
	ThemeColours.clementine,
	ThemeColours.mist,
	ThemeColours.cuppa,
	ThemeColours.forest,
	ThemeColours.teal,
];

export const CAMPAIGN_ALLOWED_COLOURS = [
	ThemeColours.cotton,
	ThemeColours.mushroom,
	ThemeColours.shroom,
	ThemeColours.pebble,
	ThemeColours.earth,
	ThemeColours.smile,
	ThemeColours.sunshine,
	ThemeColours.raspberry,
	ThemeColours.blushPink,
	ThemeColours.icing,
	ThemeColours.clementine,
	ThemeColours.mist,
	ThemeColours.cuppa,
	ThemeColours.meadow,
	ThemeColours.mint,
	ThemeColours.seaBlue,
	ThemeColours.forest,
	ThemeColours.teal,
];
